import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const Impressum = () => {
    return (
        <Box sx={{
            minHeight: '100vh',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Arial, sans-serif',
            p: 3,
        }}>
            <Container maxWidth="md">

                <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
                    Impressum
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Herausgeber
                </Typography>
                <Typography variant="body1" component="div">
                    Technische Universität München<br />
                    Arcisstraße 21<br />
                    80333 München<br />
                    Telefon: +4989289-01<br />
                    <Link href="mailto:poststelle@tum.de">poststelle@tum.de</Link>
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Vertretungs­berechtigt
                </Typography>
                <Typography variant="body1" paragraph>
                    Die Technische Universität München wird gesetzlich vertreten durch den Präsidenten Prof. Dr. Thomas F. Hofmann.
                </Typography>
                <Typography variant="body1" paragraph>
                    Die Technische Universität München ist gemäß Art. 11 Abs. 1 S. 1 BayHSchG eine Körperschaft des öffentlichen Rechts mit dem Recht der Selbstverwaltung im Rahmen der Gesetze und zugleich gemäß Art. 1 Abs. 2 Satz 1 Nr. 1 BayHSchG staatliche Hochschule (staatliche Einrichtung). Die Technische Universität München nimmt eigene Angelegenheiten als Körperschaft (Körperschaftsangelegenheiten) unter der Rechtsaufsicht der Aufsichtsbehörde, staatliche Angelegenheiten als staatliche Einrichtung wahr (Art. 12 Abs. 1 BayHSchG).
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Zuständige Aufsichtsbehörde
                </Typography>
                <Typography variant="body1" paragraph>
                    Bayerisches Staatsministerium für Wissenschaft und Kunst, Salvatorstraße 2, 80333 München.
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Umsatzsteuer­identifikations­nummer
                </Typography>
                <Typography variant="body1" paragraph>
                    DE811193231 (gemäß § 27a Umsatzsteuergesetz)
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Inhaltlich verantwortlich
                </Typography>
                <Typography variant="body1" component="div">
                    Prof. Dr. Florian Matthes<br />
                    Technical University of Munich<br />
                    TUM School of Computation, Information, and Technology<br />
                    Department of Computer Science<br />
                    Chair for Software Engineering of Business Information Systems<br />
                    Boltzmannstrasse 3<br />
                    85748 Garching bei München<br />
                    E-Mail: <Link href="mailto:aline.schmidt@in.tum.de">aline.schmidt@in.tum.de</Link> (Sekretariat)
                </Typography>
                <Typography variant="body1" paragraph sx={{mt: 2}}>
                    Namentlich gekennzeichnete Internetseiten geben die Auffassungen und Erkenntnisse der genannten Personen wieder.
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Nutzungsbedingungen
                </Typography>
                <Typography variant="body1" paragraph>
                    Texte, Bilder, Grafiken sowie die Gestaltung dieses Webauftritts können dem Urheberrecht unterliegen. Nicht urheberrechtlich geschützt sind nach § 5 des Urheberrechtsgesetz (UrhG) Gesetze, Verordnungen, amtliche Erlasse und Bekanntmachungen sowie Entscheidungen und amtlich verfasste Leitsätze zu Entscheidungen und andere amtliche Werke, die im amtlichen Interesse zur allgemeinen Kenntnisnahme veröffentlicht worden sind, mit der Einschränkung, dass die Bestimmungen über Änderungsverbot und Quellenangabe in § 62 Abs. 1 bis 3 und § 63 Abs. 1 und 2 UrhG entsprechend anzuwenden sind.
                </Typography>
                <Typography variant="body1" paragraph>
                    Als Privatperson dürfen Sie urheberrechtlich geschütztes Material zum privaten und sonstigen eigenen Gebrauch im Rahmen des § 53 UrhG verwenden. Eine Vervielfältigung oder Verwendung urheberrechtlich geschützten Materials dieser Seiten oder Teilen davon in anderen elektronischen oder gedruckten Publikationen und deren Veröffentlichung ist nur mit unserer Einwilligung gestattet. Diese Einwilligung erteilen auf Anfrage die für den Inhalt Verantwortlichen. Der Nachdruck und die Auswertung von Pressemitteilungen und Reden sind mit Quellenangabe allgemein gestattet.
                </Typography>
                <Typography variant="body1" paragraph>
                    Weiterhin können Texte, Bilder, Grafiken und sonstige Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen. Auch über das Bestehen möglicher Rechte Dritter geben Ihnen die für den Inhalt Verantwortlichen nähere Auskünfte.
                </Typography>

                <Typography variant="h5" component="h2" fontWeight="bold" mt={4} gutterBottom>
                    Haftungsausschluss
                </Typography>
                <Typography variant="body1" paragraph>
                    Alle in diesem Webauftritt bereitgestellten Informationen haben wir nach bestem Wissen und Gewissen erarbeitet und geprüft. Eine Gewähr für die jederzeitige Aktualität, Richtigkeit, Vollständigkeit und Verfügbarkeit der bereit gestellten Informationen können wir allerdings nicht übernehmen. Ein Vertragsverhältnis mit den Nutzern des Webauftritts kommt nicht zustande.
                </Typography>
                <Typography variant="body1" paragraph>
                    Wir haften nicht für Schäden, die durch die Nutzung dieses Webauftritts entstehen. Dieser Haftungsausschluss gilt nicht, soweit die Vorschriften des § 839 BGB (Haftung bei Amtspflichtverletzung) einschlägig sind. Für etwaige Schäden, die beim Aufrufen oder Herunterladen von Daten durch Schadsoftware oder der Installation oder Nutzung von Software verursacht werden, übernehmen wir keine Haftung.
                </Typography>

            </Container>
        </Box>
    );
};

export default Impressum;

